import { create } from '@theme/create';

export const themed = create(
  new (function () {
    this.wrapper = {
      variant: 'flex.row.start.center',
      width: '100%',
      minHeight: '106px',
      px: 14,
      border: (t) => `1px ${t.colors.lightGray} solid`,
    };

    this.picture = {
      width: '72px',
      mr: 8,

      spinner: {
        width: '16px',
        color: 'mediumDarkGray',
        m: 'auto',
      },
    };

    this.details = {
      variant: 'flex.column.start',
    };

    this.title = {
      variant: 'text.h6',
      fontSize: 4,
      lineHeight: '20px',
      fontWeight: 500,
      letterSpacing: 'normal',
      minHeight: '20px',
    };

    this.variant = {
      variant: 'text.sm',
      fontSize: 1,
      letterSpacing: '0.12px',
      color: 'mediumDarkGray',
      minHeight: '18px',
      mt: 1,
    };

    this.priceWrapper = {
      minHeight: '18px',
      my: 2,
    };

    this.price = {
      p: {
        variant: 'text.sm',
        fontSize: 4,
        lineHeight: '20px',
      },
    };

    this.newPrice = {
      color: 'red',
      mr: 4,
    };

    this.compareAtPrice = {
      textDecoration: 'line-through',
      color: 'mediumDarkGray',
    };

    this.atc = {
      lineHeight: '18px',
      fontSize: 2,
      fontWeight: 500,
    };
  })()
);
